import Link from 'next/link';

import { jobUrl } from 'src/services/route-utils';
import Pin from './Pin';

type Props = {
    job: any;
};

export default function JobCard({ job }: Props) {
    return (
        <div className="flex h-full flex-col">
            <Link href={jobUrl(job)} className="text-primary decoration-2 underline-offset-4 hover:underline md:mb-1">
                <h3 className="text-2xl md:text-3xl">{job.title}</h3>
            </Link>
            <div className="text-primary">
                <Pin className="mr-2 inline-block align-top" aria-hidden />
                {job.city?.name}
            </div>
            <div className="border-light-green flex-1 border-b py-4 text-sm">
                <span dangerouslySetInnerHTML={{ __html: job.description_raw }} />{' '}
                <Link className="text-primary hover:underline" href={jobUrl(job)}>
                    mai mult
                </Link>
            </div>
            <div className="text-dark-green/50 mt-4 flex items-center">
                <div className="flex-1 items-center">Tip job: {job.job_type}</div>
                <Link href={jobUrl(job)} className="btn btn-primary w-1/2 text-center md:w-1/3 xl:w-1/5">
                    Aplică
                </Link>
            </div>
        </div>
    );
}
